import BaseDialogTitle from '@material-ui/core/DialogTitle';

import styled from '@emotion/styled';
import theme from '../../themes/default';

export const StyledDialogTitle = styled(BaseDialogTitle)`
  font-size: ${theme.font.size.large};
  display: flex;
  flex-direction: row;
  padding: ${({ padding }) =>
    padding ||
    `${theme.spacing.xLarge} ${theme.spacing.large} 12px
    ${theme.spacing.large}`};
  position: sticky;
  z-index: 2;
  top: 0;
  background-color: ${theme.color.white};
  border-bottom: 1px solid ${theme.color.designSystem.blackOpacity12};
  & > .dialog-title-area {
    width: 100%;
    font-size: ${theme.font.size.large};
    line-height: ${theme.font.lineHeight.copy};
    font-weight: ${theme.font.weight.semiBold};
    color: ${theme.color.designSystem.blackOpacity87};
  }
`;

export const IconButtonContainer = styled('div')`
  position: absolute;
  right: 19px;
  top: 19px;
`;
